<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">NCR Quality</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">NCR Number</label>
                <input type="text" class="form-control" id="ncr-no" v-model="nq.ncrNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Reported Date</label>
                <flat-pickr class="form-control" v-model="nq.ncrDate" disabled></flat-pickr>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="description" v-model="nq.description" rows="3" disabled></textarea>
            </div>
        </div>
        <br />
        Root Cause Analysys & Corrective and Preventive Action Internal Data
        <app-datatable :type="'view'" :newData="newNcrCorrectivePreventiveInternal" :elements="dtElementsCorrectivePreventiveInternal" :collections="nq.ncrCorrectivePreventiveInternal"></app-datatable>
        <br /><br />
        <!-- Corrective External Data
        <app-datatable :type="'view'" :newData="newNcrCorrectiveExternal" :elements="dtElementsExternal" :collections="nq.ncrCorrectiveExternal"></app-datatable>
        <br /><br /> -->
        Action Tracker Log (Revision)
        <app-datatable :type="'view'" :newData="newNcrActionTrackerLog" :elements="dtElementsActionTrackerLog" :collections="nq.ncrActionTrackerLog"></app-datatable>
        <br /><br />
        New Revision for Action Tracker
        <app-datatable :type="'input'" :newData="newNcrActionTrackerLogNew" :elements="dtElementsActionTrackerLogNew" :collections="nq.ncrActionTrackerLogNew"></app-datatable>
        <button type="button" class="btn btn-outline-success" @click="approve">Approve <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="reject">Reject <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-info" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrQuality, ncrCorrectiveExternal, ncrActionTrackerLog, 
    ncrActionTrackerLogNew, ncrCorrectivePreventiveInternal } from '../../models/ncrQuality'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          nq: {...ncrQuality, 
                ncrCorrectiveExternal: [], 
                ncrActionTrackerLog: [],
                ncrActionTrackerLogNew: [],
                ncrCorrectivePreventiveInternal: []},
          newNcrActionTrackerLog: ncrActionTrackerLog,
          newNcrActionTrackerLogNew: ncrActionTrackerLogNew,
          newNcrCorrectiveExternal: ncrCorrectiveExternal,
          newNcrCorrectivePreventiveInternal: ncrCorrectivePreventiveInternal,
          dtElementsCorrectivePreventiveInternal: [
              {
                title: 'Action No.',
                column: 'actionNo',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Root Cause Remark',
                column: 'rootCauseRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Type',
                column: 'actionType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Remark',
                column: 'actionRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Work Description',
                column: 'workDescription',
                type: 'text',
                width: 6,
              },
              {
                title: 'Evidence',
                column: 'evidence',
                type: 'link',
                width: 6,
              },
              {
                title: 'Responder Name',
                column: 'picName',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Target Date',
                column: 'targetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
          dtElementsExternal: [
            {
                title: 'Investigation Detail',
                column: 'investigationDetail',
                type: 'text',
                width: 8,
            },
            {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 8,
            },
            {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsActionTrackerLog: [
            {
                title: 'PIC',
                column: 'pic',
                type: 'text',
                width: 6,
            },
            {
                title: 'Email',
                column: 'email',
                type: 'text',
                width: 6,
            },
            {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'text',
                width: 6,
            },
            {
                title: 'Type',
                column: 'type',
                type: 'text',
                width: 6,
            },
            {
                title: 'Item',
                column: 'item',
                type: 'text',
                width: 6,
            },
            {
                title: 'Comment',
                column: 'remark',
                type: 'text',
                width: 6,
            },
            {
                title: 'Revised by User',
                column: 'isAnswered',
                type: 'text',
                width: 6,
            },
          ],
          dtElementsActionTrackerLogNew: [
              {
                  title: 'Action Number',
                  column: 'correctiveActionNumber',
                  type: 'lookup',
                  width: 6,
                  lookup: {
                      id: 'corrective-data',
                      title: 'Action Number data',
                      type: 'table',
                      apiUrl: `ncr-corrective-list/${this.$route.query.id}`,
                      filter: ['actionNo'],
                      fields: [
                          {
                              placeholder: 'Action Number',
                              width: 5,
                              column: 'actionNo'
                          }
                      ],
                      dtElements: [
                          {
                            title: 'Action Number',
                            column: 'actionNo',
                        },
                        {
                            title: 'Root Cause Type',
                            column: 'rootCauseType',
                        },
                        {
                            title: 'Action Type',
                            column: 'actionType',
                        },
                        {
                            title: 'PIC Name',
                            column: 'picName',
                        },
                        {
                            title: 'PIC Email',
                            column: 'picEmail',
                        }
                      ],
                      affectedField: [
                          {
                              from: 'actionNo',
                              to: 'actionNo'
                          },
                          {
                              from: 'picId',
                              to: 'picId'
                          },
                          {
                              from: 'picName',
                              to: 'picName'
                          },
                          {
                              from: 'picEmail',
                              to: 'picEmail'
                          },
                          {
                              from: 'rootCauseType',
                              to: 'rootCauseType'
                          },
                          {
                              from: 'actionType',
                              to: 'actionType'
                          },
                      ]
                  },
                  disable: true,
              },
            {
                title: 'PIC',
                column: 'picName',
                type: 'text',
                width: 4,
                disable: true,
            },  
            {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
            },
            {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'text',
                width: 4,
                disable: true,
              },
            {
                title: 'Action Type',
                column: 'actionType',
                type: 'text',
                width: 6,
                disable: true,
            },
            {
                title: 'Item',
                column: 'item',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Work Description',
                        value: 'Work Description'
                    },
                    {
                        title: 'Evidence',
                        value: 'evidence'
                    },
                ]
            },
            {
                title: 'Comment',
                column: 'remark',
                type: 'text',
                width: 6,
            },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const nqApi = api('ncr-final-approval')
            this.nq = await nqApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async approve() {
            const nqApi = api('ncr-final-approval/approve')
            if(this.$route.query.id !== undefined) {
                await nqApi.update(this.nq, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async reject() {
            const nqApi = api('ncr-final-approval/reject')
            if(this.$route.query.id !== undefined) {
                await nqApi.update(this.nq, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentnq = this.nq
            this.nq = {
                ...currentnq,
                ...data
            }
        }
    }
}
</script>